"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultSegmentVisibility = exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Add = _interopRequireDefault(require("@insided/destination/icons/Add"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _ToggleSwitch = _interopRequireDefault(require("@insided/shared/uikit/ToggleSwitch"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** Default segment visibility configuration - visible to everyone */
var getDefaultSegmentVisibility = function getDefaultSegmentVisibility() {
  return {
    enabled: false,
    segmentIds: []
  };
};
/**
 * Component for configuring segment-based visibility for mega-menu items.
 * Toggle OFF → visible to everyone
 * Toggle ON + no segments → visible to everyone
 * Toggle ON + segments → only users in those segments can see it
 */


exports.getDefaultSegmentVisibility = getDefaultSegmentVisibility;

var MenuItemSegmentVisibility = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MenuItemSegmentVisibility, _Component);

  var _super = _createSuper(MenuItemSegmentVisibility);

  function MenuItemSegmentVisibility() {
    var _this;

    (0, _classCallCheck2.default)(this, MenuItemSegmentVisibility);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchText: '',
      isDropdownOpen: false,
      pendingSegmentIds: (0, _toConsumableArray2.default)(_this.props.config.segmentIds)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (event) {
      if (_this.dropdownRef.current && !_this.dropdownRef.current.contains(event.target)) {
        _this.handleCancel();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleToggleChange", function () {
      var _this$props = _this.props,
          config = _this$props.config,
          onChange = _this$props.onChange;
      onChange({
        enabled: !config.enabled,
        segmentIds: config.segmentIds
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePendingSegmentToggle", function (segmentId) {
      var pendingSegmentIds = _this.state.pendingSegmentIds;
      var segmentIdsSet = new Set(pendingSegmentIds);

      if (segmentIdsSet.has(segmentId)) {
        segmentIdsSet.delete(segmentId);
      } else {
        segmentIdsSet.add(segmentId);
      }

      _this.setState({
        pendingSegmentIds: Array.from(segmentIdsSet)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleApply", function () {
      var _this$props2 = _this.props,
          config = _this$props2.config,
          onChange = _this$props2.onChange;
      var pendingSegmentIds = _this.state.pendingSegmentIds;
      onChange({
        enabled: config.enabled,
        segmentIds: pendingSegmentIds
      });

      _this.setState({
        isDropdownOpen: false,
        searchText: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCancel", function () {
      _this.setState({
        isDropdownOpen: false,
        searchText: '',
        pendingSegmentIds: (0, _toConsumableArray2.default)(_this.props.config.segmentIds)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openDropdown", function () {
      _this.setState({
        isDropdownOpen: true,
        pendingSegmentIds: (0, _toConsumableArray2.default)(_this.props.config.segmentIds)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRemoveSegment", function (segmentId) {
      var _this$props3 = _this.props,
          config = _this$props3.config,
          onChange = _this$props3.onChange;
      var segmentIdsSet = new Set(config.segmentIds);
      segmentIdsSet.delete(segmentId);
      onChange({
        enabled: config.enabled,
        segmentIds: Array.from(segmentIdsSet)
      });
    });
    return _this;
  }

  (0, _createClass2.default)(MenuItemSegmentVisibility, [{
    key: "segmentIdMapping",
    get:
    /** Getter to ensure mapping stays in sync with props */
    function get() {
      return this.props.widgetPersonalisationOptions.reduce(function (acc, option) {
        acc[option.segmentId] = option;
        return acc;
      }, {});
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          config = _this$props4.config,
          widgetPersonalisationOptions = _this$props4.widgetPersonalisationOptions;
      var _this$state = this.state,
          searchText = _this$state.searchText,
          isDropdownOpen = _this$state.isDropdownOpen,
          pendingSegmentIds = _this$state.pendingSegmentIds;
      var isEnabled = config.enabled;
      var filteredSegments = widgetPersonalisationOptions.filter(function (segment) {
        return segment.segmentName.toLowerCase().includes(searchText.toLowerCase());
      });
      return (0, _preact.h)("div", {
        className: "menu-item-segment-visibility"
      }, (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__header"
      }, (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__header-left"
      }, (0, _preact.h)("span", {
        className: "menu-item-segment-visibility__label"
      }, "Visible only to selected segments")), (0, _preact.h)(_ToggleSwitch.default, {
        checked: isEnabled,
        onChange: this.handleToggleChange,
        "aria-label": "Toggle user segment visibility"
      })), isEnabled && (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__content"
      }, config.segmentIds.length > 0 && (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__tags"
      }, config.segmentIds.map(function (segmentId) {
        var segment = _this2.segmentIdMapping[segmentId];
        if (!segment) return null;
        return (0, _preact.h)("span", {
          key: String(segmentId),
          className: "menu-item-segment-visibility__tag"
        }, segment.segmentName, (0, _preact.h)("button", {
          type: "button",
          className: "menu-item-segment-visibility__tag-remove",
          onClick: function onClick() {
            return _this2.handleRemoveSegment(segmentId);
          },
          "aria-label": "Remove ".concat(segment.segmentName)
        }, (0, _preact.h)(_Close.default, {
          width: 12,
          height: 12
        })));
      })), (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__dropdown-wrapper",
        ref: this.dropdownRef
      }, (0, _preact.h)("button", {
        type: "button",
        className: "menu-item-segment-visibility__add-btn",
        onClick: this.openDropdown
      }, (0, _preact.h)(_Add.default, {
        width: 16,
        height: 16
      }), (0, _preact.h)("span", null, "Add User Segment")), isDropdownOpen && (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__dropdown"
      }, (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__search-wrapper"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search User Segments",
        value: searchText,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.setState({
            searchText: e.target.value
          });
        },
        onClear: function onClear() {
          return _this2.setState({
            searchText: ''
          });
        }
      })), (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__separator"
      }), (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__segment-list"
      }, filteredSegments.map(function (segment) {
        return (0, _preact.h)("div", {
          key: String(segment.segmentId),
          className: "menu-item-segment-visibility__segment-item ".concat(pendingSegmentIds.includes(segment.segmentId) ? 'menu-item-segment-visibility__segment-item--selected' : '')
        }, (0, _preact.h)(_Checkbox.default, {
          label: segment.segmentName,
          checked: pendingSegmentIds.includes(segment.segmentId),
          onUpdate: function onUpdate() {
            return _this2.handlePendingSegmentToggle(segment.segmentId);
          },
          customClass: "menu-item-segment-visibility__segment-checkbox"
        }));
      }), filteredSegments.length === 0 && (0, _preact.h)("p", {
        className: "menu-item-segment-visibility__no-segments"
      }, "No segments found")), (0, _preact.h)("div", {
        className: "menu-item-segment-visibility__actions"
      }, (0, _preact.h)("button", {
        type: "button",
        className: "menu-item-segment-visibility__btn menu-item-segment-visibility__btn--primary",
        onClick: this.handleApply
      }, "Apply"), (0, _preact.h)("button", {
        type: "button",
        className: "menu-item-segment-visibility__btn menu-item-segment-visibility__btn--secondary",
        onClick: this.handleCancel
      }, "Cancel"))))));
    }
  }]);
  return MenuItemSegmentVisibility;
}(_preact.Component);

var _default = MenuItemSegmentVisibility;
exports.default = _default;